<template>
  <v-card
    class="mx-auto EK-card IMThemeGray rounded-xl rounded-tr-0 overflow-hidden text-right pb-5"
  >
    <v-card-title class="justify-content-center text-white">
      <strong>إرسال رسالة SMS</strong>
    </v-card-title>
    <v-form @submit.prevent="submitForm" ref="sendSMS" v-model="valid">
      <v-card-text class="pb-0">
        <v-col>
          <v-row>
            <v-col cols="12" lg="6" v-if="!!smsDto.id">
              <label for="username">
                <img
                  src="/media/svg/document-notification.svg"
                  width="24"
                  class="ml-2"
                  alt="pen"
                />
                الموظف المعالج للطلب
              </label>
              <v-text-field
                v-model="smsDto.userFullName"
                disabled
                class="rounded-tr-0"
                id="fullName"
                dense
                rounded
                solo
              ></v-text-field>
            </v-col>
            <v-col cols="12" lg="6" v-if="!!smsDto.id">
              <label for="sendDate">
                <img
                  src="/media/svg/document-notification.svg"
                  width="24"
                  class="ml-2"
                  alt="pen"
                />
                تاريخ المعالجة
              </label>
              <v-text-field
                :value="smsDto.sendDate | formatDate"
                disabled
                class="rounded-tr-0"
                id="sendDate"
                dense
                rounded
                solo
              ></v-text-field>
            </v-col>
            <v-col cols="12">
              <label for="message">
                <img
                  src="/media/svg/document-notification.svg"
                  width="24"
                  class="ml-2"
                  alt="pen"
                />
                نص الرسالة
              </label>
              <v-textarea
                v-model="smsDto.message"
                class="rounded-tr-0"
                color="secondary"
                id="message"
                :rules="messageRule"
                rounded
                solo
                :disabled="!!smsDto.id"
              ></v-textarea>
            </v-col>
          </v-row>
        </v-col>
      </v-card-text>
      <v-card-actions class="justify-content-center">
        <v-btn
          v-if="!smsDto.id"
          type="submit"
          :disabled="!valid"
          class="by-5 px-10 rounded-tr-0"
        >
          تم
        </v-btn>
        <v-btn
          v-if="!smsDto.id"
          type="button"
          outlined
          color="error"
          class="by-5 px-10 rounded-tr-0"
          @click="close"
        >
          إلغاء
        </v-btn>
        <v-btn
          v-else
          type="button"
          color="white"
          outlined
          class="by-5 px-10 rounded-tr-0"
          @click="close"
        >
          تراجع
        </v-btn>
      </v-card-actions>
    </v-form>
  </v-card>
</template>

<script>
import { mapActions } from "vuex";
export default {
  data: () => ({
    valid: false,
    message: "",
    messageRule: [(v) => !!v || "يرجى إدخال نص الرسالة"],
  }),
  props: {
    smsDto: Object,
  },
  methods: {
    ...mapActions(["handleOrder"]),
    close() {
      this.$emit("close");
      this.$refs.sendSMS.reset();
    },
    submitForm() {
      this.handleOrder(this.smsDto);
      this.close();
    },
  },
};
</script>
